module.exports = __webpack_public_path__ + "img/sas-background.2bff38c.jpg";